import React from 'react';
import PropTypes from 'prop-types';
import { LazyImage } from 'project/lazy-image';
import { LiveEventSelect } from 'components/live-event-select';

const LiveStatsBar = ({ choices, setRound, setType }) => {
    return (
        <div className="live-stats-bar">
            {
                choices.roundChoices &&
                choices.roundChoices.length === 1 &&
                <div className="single-round">{choices.roundChoices[0].label}</div>
            }
            {
                choices.roundChoices.length > 1 &&
                <div className="live-stats-bar__round-dropdown">
                    <LiveEventSelect choices={choices.roundChoices} onChange={setRound} />
                </div>
            }
            <div className="live-stats-bar__patron ntt-data-logo">
                <LazyImage image={'/-/media/Patrons/nttdata-logo-white.png'}/>
            </div>
            {
                choices.roundChoices &&
                choices.roundChoices.length &&
                <div className="live-stats-bar__type-dropdown">
                    <LiveEventSelect choices={choices.typeChoices} onChange={setType} />
                </div>
            }
        </div>
    );
};

LiveStatsBar.propTypes = {
    choices: PropTypes.shape({
        roundChoices: PropTypes.Array,
        typeChoices: PropTypes.Array,
    }),
    setRound: PropTypes.func,
    setType: PropTypes.func
};

export default LiveStatsBar;
